import { addMessages } from '@hana/i18n';

// Chuỗi giao diện (mã nghiệp vụ, tên riêng, dữ liệu mẫu không dịch).
addMessages('vi', {
  'imp.retry': 'Thử lại',
  'imp.openIssue': 'Mở sự cố',
  'imp.ownOnly': 'Chỉ hiện lô hàng của khách anh/chị phụ trách.',
  'imp.code': 'Mã',
  'imp.csOwner': 'CS phụ trách · nhận xử lý',
  'imp.unassigned': 'Chưa giao',
  'imp.arAssigned': 'Kế toán công nợ · được giao',
  'imp.trip': 'Chuyến vận tải',
  'imp.transport': 'Vận tải ↗',
  'imp.milestone': 'Mốc',
  'imp.notifyCustomer': 'Báo khách',
  'imp.needAction': 'Cần xử lý',
  'imp.noOpenTask': 'Không còn việc mở',
  'imp.jobDetail': 'Chi tiết job ↗',
  'imp.month': 'Tháng 10/2026',
  'imp.soonFee': 'Cont sắp phát sinh phí',
  'imp.daysUsed': 'ngày đã dùng / free time',
  'imp.demByCarrier': 'Cont phát sinh DEM/DET theo hãng',
  'imp.contOct': 'cont · tháng 10',
  'imp.customsFlow': 'Luồng hải quan tháng',
  'imp.decl': 'tờ khai',
  'imp.incidents': 'Sự cố & claim',
  'imp.openTab': 'Mở tab',
  'imp.filter': 'Lọc',
  'imp.flow': 'Luồng duyệt',
  'imp.cancel': 'Huỷ',
  'imp.sendReq': 'Gửi đề nghị',
  'imp.confirm': 'Xác nhận',
  'imp.sendCustomer': 'Gửi khách',
  'imp.channel': 'Kênh',
  'imp.submit': 'Gửi duyệt',
  'imp.bearer': 'Người chịu',
  'imp.keepFile': 'Giữ hồ sơ',
  'imp.clmTask': 'Tạo task CLM cho CS phụ trách, hạn theo loại bên có lỗi',
  'imp.openFile': 'Mở hồ sơ',
  'imp.faultParty': 'Bên có lỗi',
  'imp.closePanel': 'Đóng bảng',
});

addMessages('en', {
  'imp.retry': 'Retry',
  'imp.openIssue': 'Open incident',
  'imp.ownOnly': 'Only shipments of customers you are in charge of are shown.',
  'imp.code': 'Code',
  'imp.csOwner': 'CS in charge · takes the case',
  'imp.unassigned': 'Unassigned',
  'imp.arAssigned': 'Receivables accountant · assigned',
  'imp.trip': 'Transport trip',
  'imp.transport': 'Transport ↗',
  'imp.milestone': 'Milestone',
  'imp.notifyCustomer': 'Notify customer',
  'imp.needAction': 'Needs action',
  'imp.noOpenTask': 'No open tasks',
  'imp.jobDetail': 'Job details ↗',
  'imp.month': 'October 2026',
  'imp.soonFee': 'Containers about to incur fees',
  'imp.daysUsed': 'days used / free time',
  'imp.demByCarrier': 'Containers incurring DEM/DET by carrier',
  'imp.contOct': 'containers · October',
  'imp.customsFlow': 'Customs flow this month',
  'imp.decl': 'declarations',
  'imp.incidents': 'Incidents & claims',
  'imp.openTab': 'Open tab',
  'imp.filter': 'Filter',
  'imp.flow': 'Approval flow',
  'imp.cancel': 'Cancel',
  'imp.sendReq': 'Send request',
  'imp.confirm': 'Confirm',
  'imp.sendCustomer': 'Send to customer',
  'imp.channel': 'Channel',
  'imp.submit': 'Submit for approval',
  'imp.bearer': 'Borne by',
  'imp.keepFile': 'Keep file',
  'imp.clmTask': 'Create CLM task for the CS in charge, due date by type of party at fault',
  'imp.openFile': 'Open file',
  'imp.faultParty': 'Party at fault',
  'imp.closePanel': 'Close panel',
});
